var map = {
	"./da-DK.json": 76087,
	"./de-DE.json": 87521,
	"./en-GB.json": 58575,
	"./en-US.json": 29862,
	"./es-ES.json": 2475,
	"./es-MX.json": 8330,
	"./fr-FR.json": 24675,
	"./it-IT.json": 87641,
	"./nb-NO.json": 37812,
	"./nl-NL.json": 40455,
	"./pl-PL.json": 11199,
	"./pt-BR.json": 84811,
	"./pt-PT.json": 30175,
	"./sv-SE.json": 69452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18371;